import React from "react";
import { Navigate, Outlet } from "react-router-dom";
export default function PrivetRoute() {
  const auth = window.localStorage.getItem("auth");
  return auth ? <Outlet /> : <Navigate to="/" />;
}
